// extracted by mini-css-extract-plugin
export default {"filtersIllustration":"styles-module__filtersIllustration__d1d1fa186ffd3e8adec0"};